import React, { useCallback } from "react";
import { landingAssets } from "config/landing";

export const Header: React.FC = () => {
  const landingLogo = landingAssets.logos.main;
  const logoAlt = landingLogo.alt ?? landingAssets.metadata.pageTitle;

  const handleContactClick = useCallback(() => {
    if (typeof document === "undefined") return;

    const contactSection = document.getElementById("contact-section");
    contactSection?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <>
      <header className="fixed h-20 lg:h-24 left-0 right-0 top-0 z-50 flex w-screen flex-row items-center justify-between gap-4 shadow-xl bg-gray-800 px-3 py-3 text-white md:px-5 lg:px-10 lg:py-6 2xl:px-20">
        <a href="/" className="inline-flex" aria-label="Go to homepage">
          <img
            src={landingLogo.src}
            alt={logoAlt}
            className="h-10 w-32 lg:h-14 lg:w-44 hover:cursor-pointer"
            loading="lazy"
          />
        </a>

        <button
          type="button"
          onClick={handleContactClick}
          className="h-11 w-auto rounded-md bg-primary px-6 text-sm font-extrabold text-white transition hover:-translate-y-0.5 lg:h-12 lg:text-xl"
        >
          Contact Us
        </button>
      </header>
      <div className="h-20 w-full lg:h-24" aria-hidden="true" />
    </>
  );
};
